var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page gc" },
    [
      _c("SideMenu"),
      _vm._v(" "),
      _c("div", { staticClass: "page-content g9" }, [
        _c("h2", [_vm._v("Password")]),
        _vm._v(" "),
        _c(
          "form",
          {
            attrs: { action: "#", method: "post", id: "form" },
            on: { submit: _vm.onSubmit },
          },
          [
            _c("FormBuilder", {
              attrs: { formData: _vm.formData, formValue: _vm.memberPassword },
            }),
            _vm._v(" "),
            _c(
              "button",
              { staticClass: "right", class: { loading: _vm.isLoading } },
              [_vm._v("Save")]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _vm.showPasswordSuccess
          ? _c(
              "div",
              {
                staticClass: "modal show",
                on: { click: _vm.onClosePasswordSuccess },
              },
              [
                _c("div", { staticClass: "modal-content" }, [
                  _vm._m(0),
                  _vm._v(" "),
                  _c(
                    "article",
                    [
                      [
                        _vm._v(
                          "\n                        Your password has been successfully changed.\n                    "
                        ),
                      ],
                    ],
                    2
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("header", [
      _vm._v("Password Changed"),
      _c("span", { attrs: { title: "Close" } }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }